// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__9DTps","requiredAsterisk":"Info_requiredAsterisk__3Kn84"};